import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import BryxColors from "../types/theme";
import { dropKeys } from "@bryxinc/ts-utils";
const borderVariantMapping = (palette) => (palette == "light"
    ? {
        text: "none",
        outlined: `solid 0.5px ${BryxColors.notify(palette, "inactive")}`,
        contained: `solid 0.5px ${BryxColors.brand1(palette)}`,
    }
    : {
        text: "none",
        outlined: `solid 0.5px ${BryxColors.brand3(palette)}`,
        contained: `solid 0.5px ${BryxColors.brandPrimary(palette)}`,
    });
const BryxButton = styled((props) => (_jsx(Button, { ...dropKeys(props, ["touchRippleRef", "ref"]), disableRipple: true })))(({ variant, theme }) => {
    const lightMode = theme.palette.mode == "light";
    return {
        borderRadius: "4px",
        height: "34px",
        fontSize: "13px",
        padding: "8px 24px",
        border: borderVariantMapping(theme.palette.mode)[variant || "text"],
        boxShadow: "none",
        backgroundColor: variant == "contained"
            ? `${lightMode ? BryxColors.brand1(theme.palette.mode) : BryxColors.brandPrimary(theme.palette.mode)}`
            : "transparent",
        fontWeight: 400,
        lineHeight: "18px",
        textTransform: "none",
        fontStyle: "normal",
        color: variant == "contained" || theme.palette.mode == "dark" ? BryxColors.darkBrand(4) : BryxColors.lightBrand(-2),
        fill: variant == "contained" || theme.palette.mode == "dark" ? BryxColors.darkBrand(4) : BryxColors.lightBrand(-2),
        "&:hover": {
            backgroundColor: !variant || variant == "text"
                ? "unset !important"
                : `${lightMode ? BryxColors.brandPrimary(theme.palette.mode) : BryxColors.brand1(theme.palette.mode)}`,
            color: !variant || variant == "text" ? BryxColors.brand1(theme.palette.mode) : BryxColors.brand4(theme.palette.mode),
            border: !variant || variant == "text" ? "none" : `0.5px solid ${BryxColors.brand1(theme.palette.mode)}`,
            boxShadow: "none",
            "& *": {
                fill: !variant || variant == "text" ? BryxColors.brand1(theme.palette.mode) : BryxColors.brand4(theme.palette.mode),
            },
        },
        "&:active, &.Mui-active": {
            boxShadow: "none !important",
            backgroundColor: !variant || variant == "text" ? "unset !important" : `${BryxColors.brandPrimary(theme.palette.mode)} !important`,
            color: `${BryxColors.brand2(theme.palette.mode)} !important`,
        },
    };
});
export default BryxButton;
